export const fontFamilies = {
    regular: "Satoshi-Regular",
    medium: "Satoshi-Medium",
    bold: "Satoshi-Bold",
    black: "Satoshi-Black",
};
export const fontSizes = {
    displayLarge: 57,
    displayMedium: 45,
    displaySmall: 36,
    headlineLarge: 32,
    headlineMedium: 28,
    headlineSmall: 24,
    titleLarge: 22,
    titleMedium: 18,
    titleSmall: 16,
    bodyLarge: 16,
    bodyMedium: 14,
    bodySmall: 12,
    labelLarge: 14,
    labelMedium: 12,
    labelSmall: 11,
};
export const lineHeights = {
    displayLarge: 68.4,
    displayMedium: 54,
    displaySmall: 43.2,
    headlineLarge: 38.4,
    headlineMedium: 33.6,
    headlineSmall: 28.8,
    titleLarge: 26.4,
    titleMedium: 21.6,
    titleSmall: 19.2,
    bodyLarge: 22,
    bodyMedium: 20,
    bodySmall: 17,
    labelLarge: 19.6,
    labelMedium: 16.8,
    labelSmall: 15.4,
};
export const letterSpacings = {
    displayLarge: -0.2,
    displayMedium: -0.2,
    displaySmall: -0.2,
    headlineLarge: -0.4,
    headlineMedium: -0.4,
    headlineSmall: -0.4,
    titleLarge: -0.4,
    titleMedium: -0.3,
    titleSmall: -0.3,
    bodyLarge: -0.2,
    bodyMedium: -0.2,
    bodySmall: -0.1,
    labelLarge: -0.2,
    labelMedium: -0.2,
    labelSmall: -0.2,
};
//# sourceMappingURL=typography.js.map